import React from 'react';
import { useNotifications } from '../contexts/NotificationContext';
import { FiHome, FiMapPin, FiBriefcase } from 'react-icons/fi';

const BottomNavigation = () => {
  const { activeTab, changeTab, unreadCounts } = useNotifications();

  return (
    <nav className="bottom-nav">
      <div 
        className={`nav-item ${activeTab === 'home' ? 'active' : ''}`}
        onClick={() => changeTab('home')}
      >
        <FiHome className="nav-icon" />
        <span className="nav-label">Home</span>
        {unreadCounts.total > 0 && (
          <span className="nav-badge">{unreadCounts.total}</span>
        )}
      </div>
      <div 
        className={`nav-item ${activeTab === 'cities' ? 'active' : ''}`}
        onClick={() => changeTab('cities')}
      >
        <FiMapPin className="nav-icon" />
        <span className="nav-label">Cities</span>
        {unreadCounts.city > 0 && (
          <span className="nav-badge">{unreadCounts.city}</span>
        )}
      </div>
      <div 
        className={`nav-item ${activeTab === 'business' ? 'active' : ''}`}
        onClick={() => changeTab('business')}
      >
        <FiBriefcase className="nav-icon" />
        <span className="nav-label">Business</span>
        {unreadCounts.business > 0 && (
          <span className="nav-badge">{unreadCounts.business}</span>
        )}
      </div>
    </nav>
  );
};

export default BottomNavigation;